import React, { useEffect, useState, useRef, forwardRef } from 'react';
import { useLocation } from 'react-router-dom';
import { Utils,ElementVisibilityChecker } from '../../Utils.js';
import i18n from '../../i18n/i18n.js';
import PageHeader from "../../components/PageHeader/PageHeader.js";
import { ReactSVG } from "react-svg";
import { motion } from "framer-motion"
import TypedLink from '../../components/TypedLink/TypedLink.js';
import ProductListItem from '../../components/ProductListItem/ProductListItem.js';
import ProuctsFilters from '../../components/ProductsFilters/ProductsFilters.js';
import Search from '../../components/Search/Search.js';
import ProductListControlls from '../../components/ProductListControlls/ProductListControlls.js';
import Minicart from '../../components/Minicart/Minicart.js';
import { AppContext } from '../../contexts/AppContext.js';
import AuthPrompt from '../../components/AuthPrompt/AuthPrompt.js';

import './Products.css';


const Products = forwardRef(function(props, ref) {

    const ProductsListRef = useRef();
    const ProductsFilterRef = useRef();

    const location = useLocation();
    const [serverData, setServerData] = useState({runs: 0}); // runs: kell egy változó érték a render legfelső dom eleméhez, mert enélkül a useState soha nem érhet véget... (nem fut le a render, hiába változott a serverData)
    const [scrollTo, setScrollTo] = useState(0);
    const [filterKey, setFilterKey] = useState(0);
    const [filterClicked, setFilterClicked] = useState({clicked:0});
    const [filterVisible, setFilterVisible] = useState({visible:0});
    const [loadMore,setLoadMore] = useState({loading:0});
    const [filtersShouldAnimateOnMount, setFiltersShouldAnimateOnMount] = useState(true);
    const [activeFiltersCount, setActiveFiltersCount] = useState(0);
    const isFavorites = props.isFavorites || false;
    const appRef = React.useContext(AppContext).appRef;
    const isLoggedIn = appRef.current.get_is_signed();

    let loading = 0;

    useEffect(() => {

        setServerData({runs: 0, loaded:0})

        const cache_data = check_back_cache();

        if(cache_data && Object.keys(cache_data).length>0 && cache_data.serverData){
            setServerData(cache_data.serverData);
            if(cache_data.scrollPosTop){
                setScrollTo(cache_data.scrollPosTop);
            }
        }else{
            get_product_list_from_api();
        }

    }, [location]);

    const set_product_list_order_by = (set_to)=>{
        const set_val  = set_to.target.value ? set_to.target.value : set_to;
        delete_back_cache();
        get_product_list_from_api({products_order_by:set_val});
    }

    const get_product_list_from_api = (post_data,external_query_string,cb,options = {})=>{

        const { keepFiltersVisible = false } = options;

        if (keepFiltersVisible) {
            setFiltersShouldAnimateOnMount(false);
        }

        let query_string = { APICACHE: true };
        const search_params = external_query_string || Object.fromEntries(new URLSearchParams(location.search));
        const post = (post_data) ? post_data : {};
        const base_url = isFavorites ? ('/products/'+appRef.current?.product_url) : location.pathname;

        if(Object.keys(search_params).length>0){
            query_string = {...query_string,...search_params};
        }
        
        if(isFavorites){
            query_string.favorites = 1;
        }       

        Utils.get_server_data(base_url, query_string, post).then((resp) => {

            // hálózati hiba esetén marad a korábbi lista, ne ürüljön ki a képernyő
            if (!resp || resp.error_request) return;

            resp.runs = 0;

            const keySource = external_query_string && Object.keys(external_query_string).length>0 ? external_query_string : query_string;
            const filterKeySignature = JSON.stringify(keySource || {});

            setFilterKey(filterKeySignature);
            setServerData(resp);

            if (keepFiltersVisible) {
                setFilterClicked((prev)=> (prev?.clicked ? prev : {clicked:1}));
            } else {
                setFilterClicked({clicked:0});
            }

            if (!keepFiltersVisible) {
                setFiltersShouldAnimateOnMount(true);
            }
          
            if(cb && typeof cb == 'function'){
                cb(resp);
            }
        });

    }

    useEffect(() => {
        if (scrollTo && (scrollTo > 0)) {
            setTimeout(() => {
                const scrollContainer = document.querySelector(".container.products_list .floating_container_content");
                if(scrollContainer) {
                    scrollContainer.scrollTo(0, scrollTo);
                }
                setScrollTo(0);
            }, 100);
        }
    }, [scrollTo]);

    const onFiltersChange = (filters_post_data, reportedActiveCount) => {
        const nextActiveCount = typeof reportedActiveCount === 'number'
            ? reportedActiveCount
            : (typeof filters_post_data?.activeFiltersCount === 'number' ? filters_post_data.activeFiltersCount : 0);

        setActiveFiltersCount(nextActiveCount);

        if (filters_post_data?.trigger === 'sync') {
            return;
        }

        set_url_query_string_param(filters_post_data?.queryString);
        delete_back_cache();
        get_product_list_from_api({},filters_post_data?.queryObject,undefined,{ keepFiltersVisible: true });
    }
   
    const set_url_query_string_param = (query_string) => {
        if (typeof window === 'undefined') {
            return;
        }

        const sanitized = (typeof query_string === 'string' ? query_string.trim() : '')
            .replace(/^\?+/, '');

        const currentSearch = window.location.search.replace(/^\?/, '');

        if (currentSearch === sanitized) {
            return;
        }

        const nextSearch = sanitized.length > 0 ? `?${sanitized}` : '';
        const nextUrl = `${window.location.pathname}${nextSearch}${window.location.hash || ''}`;

        window.history.pushState({}, '', nextUrl);
    }

    const clickSetFilterVisible = (set_to) =>{

        if(set_to===1){
            setFilterClicked({'clicked':1});
            setFiltersShouldAnimateOnMount(true);
        }

        if(set_to===0){
            setFiltersShouldAnimateOnMount(true);
        }

        filterVisible.visible = set_to;
        setFilterVisible({...filterVisible});
    }

    function load_more_products(loading_button)
    {
        const current_products = serverData.products.product_page_products.products;
        // HTML decode: &amp; → &
        const next_url = serverData.pager.next.replace(/&amp;/g, '&');
        const products_paged_url = '/products' + next_url;

        if(loading===0){

            loading = 1;
            setLoadMore({loading:1});
            
            Utils.get_server_data(products_paged_url).then((resp) => {

                const page_products = resp.products.product_page_products.products;
                // products.push.apply(products, page_products);
                // resp.products.product_page_products.products = products;
                
                const new_products = [...current_products, ...page_products];
                resp.products.product_page_products.products = new_products;

                resp.runs = serverData.runs + 1;

                // Az eredeti serverData-t összefűzzük az újjal, hogy pl a filterek megmaradjanak
                const newServerData = {...serverData, ...resp};
                newServerData.products.product_page_products.products = new_products;
                
                setServerData(newServerData);

                loading=0;
                setLoadMore({loading:0});
                             
            })


        }
            
    }

    function delete_back_cache()
    {
        let cache_data =  localStorage.getItem('back_cache');
        if(cache_data){
            localStorage.removeItem('back_cache');
        }
    }

    function check_back_cache()
    {
        let cache_data =  localStorage.getItem('back_cache');
        cache_data = JSON.parse(cache_data);


        if(cache_data && Object.keys(cache_data).length>0 && cache_data.urlHash && cache_data.timestamp)
        {
            const timestamp = Math.floor(Date.now() / 1000);

            //csak ha ugyan az az url és kevesebb mint 10 perc telt el
            if(btoa(location.pathname) === cache_data.urlHash && timestamp-cache_data.timestamp<300)
            {
                return cache_data;
            }
        }
    }

    const handle_fav_change = (product, is_now_favorite) => {

        // csak a kedvenc oldalon, és csak eltávolításkor kell a listából kivenni a terméket
        if (!isFavorites || is_now_favorite) {
            return;
        }

        setServerData(prev => {
            const page = prev?.products?.product_page_products;

            if (!page || !Array.isArray(page.products)) {
                return prev;
            }

            const products = page.products.filter(p => parseInt(p.id) !== parseInt(product.id));
            const pc_total = Math.max(0, (parseInt(page.pc_total) || products.length) - 1);

            return {
                ...prev,
                products: {
                    ...prev.products,
                    product_page_products: {
                        ...page,
                        products,
                        pc_total,
                    }
                }
            };
        });

        // a lista back cache-t is ürítjük, hogy visszatérve ne a régi (törölt elemet még tartalmazó) lista jöjjön
        delete_back_cache();
    }

    const set_list_back_cache = (e, product) =>{

        const timestamp = Math.floor(Date.now() / 1000);
        const scroller = document.querySelector(".container.products_list .floating_container_content");
        
        // Csak a legszükségesebb adatokat mentjük el, hogy ne lépjük túl a localStorage limitet
        // A serverData egyéb elemei (pl. nagy objektumok, debug infók) nem kellenek a visszaállításhoz
        const serverDataToCache = {
            loaded: serverData.loaded,
            pager: serverData.pager,
            products: {
                product_page_products: {
                    products: serverData.products?.product_page_products?.products || [],
                    pc_total: serverData.products?.product_page_products?.pc_total || 0,
                    pc_page: serverData.products?.product_page_products?.pc_page || 0,
                    error404: serverData.products?.product_page_products?.error404 || false
                }
            },
            filter_datas: serverData.filter_datas,
            title: serverData.title,
            list_settings: serverData.list_settings,
            percentage_discont: serverData.percentage_discont,
            product_list_controlls: serverData.product_list_controlls
        };

        const cache_data = {
            'serverData': serverDataToCache,
            'urlHash': btoa(location.pathname),
            'timestamp': timestamp,
            'scrollPosTop': scroller ? scroller.scrollTop : 0
        };

        try {
            localStorage.setItem('back_cache',JSON.stringify(cache_data));
        } catch (error) {
            console.warn('LocalStorage QuotaExceededError:', error);
            // Ha még mindig túl nagy, próbáljuk meg filterek nélkül
             try {
                 const minimalCache = {...cache_data};
                 minimalCache.serverData = {...serverDataToCache};
                 delete minimalCache.serverData.filter_datas;
                 localStorage.setItem('back_cache',JSON.stringify(minimalCache));
             } catch(e) {
                 console.warn('Failed to save minimal back_cache too');
             }
        }
    }

    function render_top_category_select() {

            return <div className='prpduct_list_cat_select_top_cont'>
                {
                (serverData?.list_settings?.filters?.next_lvl_categories!==undefined && Object.keys(serverData?.list_settings?.filters?.next_lvl_categories).length>0) ? 
                <motion.ul
                initial={{ opacity: 0}}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.3 }} 
                className='prpduct_list_cat_select_top'>
                    {Object.entries(serverData?.list_settings?.filters?.next_lvl_categories).map(function(val,index){
                        return <li key={val[0]}><TypedLink link={{ type: 'products', url: val[1].url, title: val[1].label }} /></li>
                    })}
                </motion.ul>
                : ''}
                
            </div>

    }

    let header_title = (serverData.title) ? serverData.title : i18n.t('productListDefaultTitle');
    header_title = isFavorites ? i18n.t('productListFavoritesTitle') : header_title;
    console.log(isFavorites, serverData.title, header_title);
    const product_count = (serverData.products && serverData.products.product_page_products) ? serverData.products.product_page_products.pc_total : 0;

    return (
        <>
            <>{filterClicked.clicked && serverData.loaded===1 ?  
                <ProuctsFilters
                isVisible={filterVisible.visible}
                hideFromParent={clickSetFilterVisible} 
                key={filterKey}
                filterData={serverData.filter_datas}
                onFiltersChange={onFiltersChange}
                productCount={product_count}
                disableInitialAnimation={!filtersShouldAnimateOnMount}
                ></ProuctsFilters> : ''}</>

            <div className={`container floating_container products_list`}>
                <div className='floating_container_inner'>
                {
                    serverData.loaded===1 
                    ?
                        (product_count) ? <>
                            <div className='floating_container_header'>
                                <PageHeader isHistoryBack="true"  no_close="true" custom_icons={[<Minicart></Minicart>]} title={<Search placeholder={header_title} />} >
                                    <ProductListControlls 
                                        onToggleFilter={clickSetFilterVisible}
                                        sortBy={serverData.product_list_controlls.products_order_by}
                                        productCount={serverData.products.product_page_products.pc_total}
                                        activeFiltersCount={activeFiltersCount}
                                        onSortChange={set_product_list_order_by}>
                                    </ProductListControlls>
                                </PageHeader>
                            </div>
                            {/*<PageHeader isHistoryBack="true" parent_ref={this} no_close="true" title={(serverData.title) ? serverData.title : i18n.t('productListDefaultTitle')} ></PageHeader>*/}
                            
                            <div className='floating_container_content'>
                                {render_top_category_select()}
                            
                                <div className={"product_list_inner" +  (serverData.signatures || serverData.percentage_discont ? ' no_categories' : '')}>
                                    {serverData.percentage_discont ? <div className='percentage_discount_details_cont' dangerouslySetInnerHTML={{__html:serverData.percentage_discont.description}}></div> : ''}
                                    {/*<HeaderBanner text="Ingyenes szállítás 14 999 Ft felett" url="/szallitas" url-type=""></HeaderBanner>*/}
                                    {/*<RecommendedProducts></RecommendedProducts>*/}
                                    <div className='product-list-items-cont'>
                                        {serverData.products.product_page_products && serverData.products.product_page_products.products.map((product, index) => {
                                            product.index = index + 1;

                                            return <ProductListItem
                                                parentFunction={set_list_back_cache}
                                                ref={ProductsListRef} key={`${product.id + '_' + serverData.runs}`}
                                                product={product}
                                                show_fav_icon={true}
                                                show_product_rating={true}
                                                on_fav_change={handle_fav_change}
                                            />})
                                        }    
                                    </div>
                                    
                                    {(serverData.pager?.next) ? <div key={serverData.pager.next} className='load_products_cont'><ElementVisibilityChecker onVisible={(c)=>{load_more_products(c)}}><div className={"load-more-roducts"+((loadMore.loading==1) ? " loading" : '')}>{i18n.t('productListLoadMore')}</div></ElementVisibilityChecker></div> : ''}
                                </div>
                            </div>
                            
                            
                        </>
                        : <>
                            <PageHeader key={serverData.title} isHistoryBack="true" parent_ref={this} no_close="true" title={isFavorites ? i18n.t('productListFavoritesTitle') : '404'}></PageHeader>
                            <div className='product_list_inner'>
                                {!isLoggedIn && isFavorites ? (
                                    <AuthPrompt />
                                ) : (
                                    <div className='empty_list_msg'>{i18n.t(isFavorites ? 'productListEmptyFavoritesMsg' : 'productListEmptyListMsg')}</div>
                                )}
                            </div>
                        </>
                    :
                    <div className='loader_cont'><div className='loader'><ReactSVG src='/assets/images/loading.svg'></ReactSVG></div></div>
                }
                </div>
            </div>
        </>
    );

});

export default Products;